(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const state = { sound: localStorage.getItem('bwblin-sound') !== 'off', audio: null, lastBurst: 0 };

  function eligibleOpeningHeading() {
    const main = document.querySelector('#MainContent');
    if (!main) return;
    const template = (main.dataset.template || '').toLowerCase();
    if (/product|cart|search|gift_card/.test(template)) return;

    const candidates = [...main.querySelectorAll('h1, h2')].filter((heading) => {
      if (heading.closest('.product-information, .product-details, nav, header, footer, .button, button')) return false;
      const rect = heading.getBoundingClientRect();
      const size = parseFloat(getComputedStyle(heading).fontSize || '0');
      return rect.top < 700 && size >= 28;
    });

    candidates.slice(0, 2).forEach((heading) => heading.classList.add('biro', 'bw-opening-heading'));
  }

  function makeBubbleField() {
    if (document.querySelector('#bw-bubble-field')) return;
    const field = document.createElement('div');
    field.id = 'bw-bubble-field';
    field.setAttribute('aria-hidden', 'true');
    const values = [
      [7,24,20,-8,-26],[15,42,25,-15,38],[26,18,17,-4,-18],[37,58,27,-19,28],
      [50,30,21,-11,-34],[61,48,26,-3,24],[72,22,18,-14,-20],[82,64,28,-8,35],[93,35,23,-17,-30]
    ];
    values.forEach(([left,size,duration,delay,drift]) => {
      const b = document.createElement('span');
      b.className = 'bw-global-bubble';
      b.style.cssText = `--bw-left:${left}%;--bw-size:${size}px;--bw-duration:${duration}s;--bw-delay:${delay}s;--bw-drift:${drift}px`;
      field.appendChild(b);
    });
    document.body.appendChild(field);
  }

  function popAt(x, y) {
    if (reducedMotion.matches) return;
    const p = document.createElement('span');
    p.className = 'bw-pop'; p.style.left = `${x}px`; p.style.top = `${y}px`;
    document.body.appendChild(p); setTimeout(() => p.remove(), 650);
  }

  function gentlePops() {
    if (reducedMotion.matches) return;
    const next = () => {
      const delay = 7200 + Math.random() * 9000;
      window.setTimeout(() => {
        popAt(window.innerWidth * (.08 + Math.random() * .84), window.innerHeight * (.18 + Math.random() * .68));
        next();
      }, delay);
    }; next();
  }

  function soundToggle() {
    if (document.querySelector('.bw-sound-toggle')) return;
    const btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'bw-sound-toggle'; btn.setAttribute('aria-label', 'Toggle bubbly sound effects');
    btn.setAttribute('aria-pressed', state.sound ? 'true' : 'false');
    btn.innerHTML = '<svg class="bw-sound-on" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" d="M5 10v4h3l4 3V7L8 10H5Zm10-1.5c1 .9 1.5 2 1.5 3.5S16 14.6 15 15.5M17.5 6c1.8 1.6 2.7 3.6 2.7 6s-.9 4.4-2.7 6"/></svg><svg class="bw-sound-off" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" d="M5 10v4h3l4 3V7L8 10H5Zm10-1 5 5m0-5-5 5"/></svg>';
    btn.addEventListener('click', () => {
      state.sound = !state.sound; localStorage.setItem('bwblin-sound', state.sound ? 'on' : 'off');
      btn.setAttribute('aria-pressed', state.sound ? 'true' : 'false');
      if (state.sound) playChime(true);
    });
    document.body.appendChild(btn);
  }

  function playChime(preview = false) {
    if (!state.sound) return;
    try {
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) return;
      state.audio ||= new AudioCtx();
      const ctx = state.audio;
      if (ctx.state === 'suspended') ctx.resume();
      const now = ctx.currentTime + .01;
      const notes = preview ? [660, 880] : [523.25, 659.25, 783.99, 1046.5];
      notes.forEach((freq, i) => {
        const osc = ctx.createOscillator(), gain = ctx.createGain();
        osc.type = i % 2 ? 'sine' : 'triangle'; osc.frequency.setValueAtTime(freq, now + i * .055);
        gain.gain.setValueAtTime(.0001, now + i * .055);
        gain.gain.exponentialRampToValueAtTime(preview ? .025 : .04, now + i * .055 + .018);
        gain.gain.exponentialRampToValueAtTime(.0001, now + i * .055 + .22);
        osc.connect(gain); gain.connect(ctx.destination); osc.start(now + i * .055); osc.stop(now + i * .055 + .24);
      });
    } catch (_) {}
  }

  function burst(origin) {
    if (reducedMotion.matches) return;
    const now = Date.now(); if (now - state.lastBurst < 500) return; state.lastBurst = now;
    const rect = origin?.getBoundingClientRect?.();
    const x = rect ? rect.left + rect.width / 2 : window.innerWidth / 2;
    const y = rect ? rect.top + rect.height / 2 : window.innerHeight / 2;
    const wrap = document.createElement('div'); wrap.className = 'bw-cart-burst'; wrap.setAttribute('aria-hidden','true');
    for (let i=0;i<22;i++) {
      const b=document.createElement('i'); b.className='bw-cart-burst__bubble';
      const a=(Math.PI*2*i/22)+(Math.random()*.28); const d=70+Math.random()*150;
      b.style.cssText=`--x:${x}px;--y:${y}px;--s:${8+Math.random()*30}px;--tx:${Math.cos(a)*d}px;--ty:${Math.sin(a)*d}px;animation-delay:${Math.random()*80}ms`;
      wrap.appendChild(b);
    }
    document.body.appendChild(wrap); setTimeout(()=>wrap.remove(),1100);
  }

  function cartIconBounce() {
    const icon = document.querySelector('cart-icon, .header-actions__cart-icon, a[href*="/cart"]');
    if (!icon) return; icon.classList.remove('bw-cart-celebrate'); void icon.offsetWidth; icon.classList.add('bw-cart-celebrate');
    setTimeout(()=>icon.classList.remove('bw-cart-celebrate'),760);
  }

  document.addEventListener('cart:update', (event) => {
    const data = event.detail?.data || {};
    if (data.source !== 'product-form-component' || data.didError) return;
    const source = event.target?.closest?.('product-form-component')?.querySelector('[type="submit"], button') || document.activeElement;
    burst(source); cartIconBounce(); playChime();
  });

  function init(){ eligibleOpeningHeading(); makeBubbleField(); soundToggle(); gentlePops(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', eligibleOpeningHeading);
})();
